'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initImage360Containers = exports.getImage360ContainerData = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getImage360ContainerData = exports.getImage360ContainerData = function getImage360ContainerData(image360Container) {
  var id = image360Container.dataset.containerId;

  var _JSON$parse = JSON.parse($(image360Container).find(_Dom2.default.image360Data).text()),
      images = _JSON$parse.data;

  return {
    _data: { images: images },
    id: id,
    change: 'image360',
    container: 'image360'
  };
};

var getAllImage360ContainerData = function getAllImage360ContainerData() {
  return $(_Dom2.default.image360Container).get().map(getImage360ContainerData);
};

var initImage360Containers = exports.initImage360Containers = function initImage360Containers(data) {
  return getAllImage360ContainerData().map(function (item) {
    return _state2.default.set(item);
  });
};